export enum PriceRequestState {
  REQUESTED = 'REQUESTED', // OA
  OPEN = 'OPEN',
  RETRACTED = 'RETRACTED',
  IN_PROGRESS = 'IN_PROGRESS',
  OFFER_SENT = 'OFFER_SENT',
  PRICE_OFFER = 'PRICE_OFFER', // OA
  OFFER_EXPIRED = 'OFFER_EXPIRED',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  ACCEPTED = 'ACCEPTED', // OA
  OFFER_REJECTED = 'OFFER_REJECTED',
  REJECTED = 'REJECTED', // OA
}

export const OfferedOrRequestedPriceRequestStates = [PriceRequestState.REQUESTED, PriceRequestState.PRICE_OFFER];
